import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';
import { SharedSvgModule } from '@warema/shared/svg';
import { AppointmentsStatusLegendComponent } from './components/appointments-status-legend/appointments-status-legend.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';

@NgModule({
    imports: [
        CommonModule,
        MatSnackBarModule,
        SharedSvgModule,
        RouterModule,
        ReactiveFormsModule,
        AppointmentsStatusLegendComponent,
        BreadcrumbComponent,
    ],
    exports: [AppointmentsStatusLegendComponent, BreadcrumbComponent],
})
export class WaremaPlusScaffoldModule {}
